import { TFunction } from 'i18next';

export function getMinLengthMessage(t: TFunction) {
	return ({ min }: { min: number }) => t('min_length', { min });
}
